import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState, useContext } from "react";
import { EventContext } from './AdminEvents';
import EventImage from '../../live-show.jpg'

export default function AdminEventCard(props) {

  const { setOverviewMode, setSingleViewMode, selectedEvent, setSelectedEvent } = useContext(EventContext)

  const viewEvent = (name) => {
    setSelectedEvent(props.name)
    setSingleViewMode(true)
    setOverviewMode(false)
    console.log(name)
  }

  return (
    <Card sx={{ maxWidth: 300, minWidth: 140}}>
      <CardMedia
        component="img"
        height="140"
        image={EventImage}
        alt="desmond and the tutus"
      />
      <CardContent>
        <Typography gutterBottom variant="h8" component="div">
          {props.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {props.date}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" onClick={() => viewEvent(props.name)}>View</Button>
      </CardActions>
    </Card>
  );
}
